import { get, post } from "helpers/api_helper";
import { getUserToken } from "helpers/authHelper";
import { encryptDataToArray } from "helpers/EncDec";
import { getDeviceInfo } from "helpers/utils";

export async function FetchAllRoundTemplates(reqBody) {
  reqBody = encryptDataToArray(reqBody);

  return await post(
    "/admin/round-template/list",
    {
      q: reqBody,
    },
    {
      headers: {
        Authorization: getUserToken(),
        "X-DomainID": localStorage.getItem("subdomainId") || "",
        "X-lang_id": localStorage.getItem("lang_id") || 1,
      },
    }
  );
}

export async function FetchAllRoundTemplateOptions() {
  return await get("/admin/round-template/option/list", {
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-lang_id": localStorage.getItem("lang_id") || 1,
    },
  });
}

export async function CreateNewRoundTemplate(reqBody) {
  let device_info = await getDeviceInfo(navigator);
  reqBody = {
    ...(reqBody || {}),
    device_info: device_info,
  };

  reqBody = encryptDataToArray(reqBody);

  return await post(
    "/admin/round-template/create",
    {
      q: reqBody,
    },
    {
      headers: {
        Authorization: getUserToken(),
        "X-DomainID": localStorage.getItem("subdomainId") || "",
        "X-lang_id": localStorage.getItem("lang_id") || 1,
      },
    }
  );
}

export async function DeleteRoundTemplate(templateId) {
  let device_info = await getDeviceInfo(navigator);
  let reqBody = {
    device_info: device_info,
  };

  reqBody = encryptDataToArray(reqBody);

  return await post(
    `/admin/round-template/delete/${templateId}`,
    {
      q: reqBody,
    },
    {
      headers: {
        Authorization: getUserToken(),
        "X-DomainID": localStorage.getItem("subdomainId") || "",
        "X-lang_id": localStorage.getItem("lang_id") || 1,
      },
    }
  );
}

export async function FetchAllRounds() {
  return await get(`/admin/round-template/rounds`, {
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
      "X-lang_id": localStorage.getItem("lang_id") || 1,
    },
  });
}
